import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  min-height: 20px;
`

const SLHeader = () => (
  <Wrapper>
    <svg width="98px" height="10px" viewBox="0 0 98 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="1.0-Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Broker-Portal---Dashboard---Loading" transform="translate(-276.000000, -190.000000)" fill="#F1F1F4">
          <rect id="header" x="276" y="190" width="98" height="10"/>
        </g>
      </g>
    </svg>
  </Wrapper>
)

export default SLHeader
